import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  padding: 1.5rem 1.75rem;
  max-width: 720px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.35);
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
`;

const CloseButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  background: #e5e7eb;
  color: #374151;
  &:hover {
    background: #d1d5db;
  }
`;

const Content = styled.div`
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.6;

  h4 {
    font-size: 0.95rem;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    color: #111827;
  }

  p {
    margin-bottom: 0.75rem;
  }

  ul {
    padding-left: 1.25rem;
    margin-bottom: 0.75rem;
  }

  li {
    margin-bottom: 0.35rem;
  }
`;

const LegalModal = ({ open, onClose, title, children }) => {
  if (!open) return null;

  return (
    <Overlay onClick={onClose}>
      <Card onClick={(e) => e.stopPropagation()}>
        <HeaderRow>
          <Title>{title}</Title>
          <CloseButton type="button" onClick={onClose}>
            Kapat
          </CloseButton>
        </HeaderRow>
        <Content>{children}</Content>
      </Card>
    </Overlay>
  );
};

export default LegalModal;

